/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentPolicyGrantForm,
  AgentPolicyGrantForm$Outbound,
  AgentPolicyGrantForm$outboundSchema,
} from "./agentpolicygrantform.js";

export type CreateAgentForm = {
  name: string;
  /**
   * Eligible same-organization human owner; defaults to the caller
   */
  ownerUserId?: string | undefined;
  /**
   * Optional initial allow-only agent policy ceilings, created atomically with the agent. Effective credential permissions remain limited by the live owner and authorizer.
   */
  policyGrants?: Array<AgentPolicyGrantForm> | undefined;
  /**
   * Optional project binding. Omit or send an empty string for an organization-wide agent; independent of policy grants and the Gram-Project header.
   */
  projectId?: string | undefined;
};

/** @internal */
export type CreateAgentForm$Outbound = {
  name: string;
  owner_user_id?: string | undefined;
  policy_grants?: Array<AgentPolicyGrantForm$Outbound> | undefined;
  project_id?: string | undefined;
};

/** @internal */
export const CreateAgentForm$outboundSchema: z.ZodMiniType<
  CreateAgentForm$Outbound,
  CreateAgentForm
> = z.pipe(
  z.object({
    name: z.string(),
    ownerUserId: z.optional(z.string()),
    policyGrants: z.optional(z.array(AgentPolicyGrantForm$outboundSchema)),
    projectId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      ownerUserId: "owner_user_id",
      policyGrants: "policy_grants",
      projectId: "project_id",
    });
  }),
);

export function createAgentFormToJSON(
  createAgentForm: CreateAgentForm,
): string {
  return JSON.stringify(CreateAgentForm$outboundSchema.parse(createAgentForm));
}
